/**
 * MACD
 * 分时和K线共用
 */
import BaseContext from '../basecontext';
import FootDectorator from '../dectorator/footdectorator';
import { checkFootAuth, checkFootTitleAuth } from '../dectorator/checkauthdectorator/index.js';
import Util, { mergeModelData, curryFun } from '../../util/index.js';
import { checkExchange } from '../../controller/util.js';
import { LINE_TYPE } from '../setting.js';
const model = {
  dif: {
    Type: Array,
    Default: () => ([])
  },
  dea: {
    Type: Array,
    Default: () => ([])
  },
  macd: {
    Type: Array,
    Default: () => ([])
  },
  params: {
    type: String,
    Default: 'MACD(12,26,9)'
  }
};
export default class MACDState extends FootDectorator(BaseContext) {
  constructor({ data, ...rest }) {
    super({ ...rest, data: mergeModelData(model, data) });
  }
  _calcRange() {
    let { dif, dea, macd, code, params } = this.state.data;
    let { maxValue, minValue } = this.calcRange({ data: [dif, dea, macd], targetKey: 'value', isAdditional: true });
    // maxValue = Math.max(maxValue, Math.abs(minValue));
    // if ((maxValue.toFixed(2) == 0 && checkExchange(code)) || !Util.isValidNumber(maxValue)) {
    //   maxValue = 0.01;
    // } else {
    //   maxValue *= 1.05;
    // }
    // minValue = -maxValue;
    this.maxValue = maxValue;
    this.minValue = minValue;
  }
  _calcAxis() {
    const maxValue = this.maxValue;
    const range = maxValue * 2;
    const {
      height
    } = this.availArea;
    const ratio = height / range;
    const { dif, dea, macd, start, end } = this.state.data;
    const curryCalcAxis = curryFun(this.calcAxis, this, {
      targetKey: 'value',
      sourceKey: 'lineY',
      isAdditional: true,
    });
    curryCalcAxis({ data: dif });
    curryCalcAxis({ data: dea });
    curryCalcAxis({ data: macd, sourceKey: 'barHeight', isAdditional: false, baseValue: 0 });
  }
  _drawMain() {
    const {
      left,
      width,
      height,
      top,
      bottom,
    } = this.availArea;
    const middleY = top + height / 2;
    const { dif, dea, macd, start, end } = this.state.data;
    const line=(Math.abs(this.maxValue)+Math.abs(this.minValue)).toFixed(2)
    const origin=Number((height*(Math.abs(this.maxValue)/line)).toFixed(2))+top
    this._drawBarMacd(macd, left, origin, width);
    const { LINE } = LINE_TYPE;
    const { dif: difLine, dea: deaLine } = this.option.Macd;
    this._drawLine(LINE, dif, left, bottom, difLine.lineWidth, difLine.color);
    this._drawLine(LINE, dea, left, bottom, deaLine.lineWidth, deaLine.color);
  }
  _drawAxisY() {
    const { axisY } = this.option.Macd;
    const {
      left,
      right,
      top,
      bottom,
      height
    } = this.availArea;
    const line=Number(((Math.abs(this.maxValue)+Math.abs(this.minValue))/2).toFixed(2))
    const ctx = this.context;
    ctx.beginPath();
    ctx.textAlign = 'left';
    ctx.fillStyle = axisY.color;
    ctx.font = axisY.sizeRatio * this.state.baseSize * this.dpr + "px " + axisY.fontFamily;
    ctx.textBaseline = 'top';
    ctx.fillText(this.maxValue.toFixed(2), left, top+20);
    ctx.textBaseline = 'middle';
    ctx.fillText((this.minValue+line).toFixed(2), left, top + height / 2);
    ctx.textBaseline = 'bottom';
    ctx.fillText(this.minValue.toFixed(2), left, bottom);
  }
  // @checkFootTitleAuth
  _drawTitle() {
    const ctx2 = this.curContext;
    const { top } = this.availArea;
    const { current, sealObj, len } = this.state.data;
    const { height, baseSize } = this.state;
    const { ratioFixed } = sealObj;
    const { space } = this.option.Macd;
    const { baseLine } = this.option.FootContext.title;
    const baseLineY = top + height * baseLine-10;
    let { left } = this.availArea;
    // left+=ctx2.measureText(this.maxValue.toFixed(2)).width+10
    const {
      sizeRatio,
      fontFamily,
      axisY,
    } = this.option.Macd;
    [
      'params',
      'macd',
      'dif',
      'dea',
    ].forEach(val => {
      const data = this.state.data[val];
      if (data == 'MACD(12,26,9)') {
        let color = this.option.Macd.params.color
        ctx2.font = sizeRatio * baseSize * this.dpr + 'px' + fontFamily
        ctx2.fillStyle = color;
        ctx2.textAlign = 'left';
        ctx2.textBaseline = 'top';
        ctx2.beginPath();
        const text = data
        const textWidth = ctx2.measureText(text).width;
        ctx2.fillText(text, left, baseLineY);
        left += textWidth + 10;

      }else{
      if (Util.isArray(data)) {
        let color;
        // 绘不满常规根数时取当前数据的最后一条
        const item = data[current] || data[len - 1];
        if (val !== 'macd') {
          color = this.option.Macd[val].color;
        } else {
          const colorIndex = item ? item.barColor : '#000';
          color = this.option.BaseContext.colorMap[colorIndex] || axisY.color;
        }
        ctx2.font = sizeRatio * baseSize * this.dpr + 'px ' + fontFamily;
        ctx2.fillStyle = color;
        ctx2.textAlign = 'left';
        ctx2.textBaseline = 'top';
        ctx2.beginPath();
        if (Util.isDef(item) && Util.isValidNumber(item.value)) {
          const text = val.toUpperCase() + ': ' + item.value.toFixed(ratioFixed);
          const textWidth = ctx2.measureText(text).width;
          ctx2.fillText(text, left, baseLineY);
          left += textWidth;
        } else {
          const text = val.toUpperCase() + ': -';
          const textWidth = ctx2.measureText(text).width;
          ctx2.fillText(text, left, baseLineY);
          left += textWidth;
        }
        left += space * this.dpr;

      }
    }
    })
  }
}
